import { render, staticRenderFns } from "./OrderHistoryTab.vue?vue&type=template&id=d1eb64b4&scoped=true"
import script from "./OrderHistoryTab.vue?vue&type=script&lang=js"
export * from "./OrderHistoryTab.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderHistoryTab.vue?vue&type=style&index=0&id=d1eb64b4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d1eb64b4",
  "c2e149c0"
  
)

export default component.exports